<template>
  <div class="rowflex" style="align-items: center">
    <div style="width: 50%">
      <img style="width: 100%" src="@/assets/images/Stock/warehouse.gif" />
    </div>
    <div style="width: 50%">
      <ul style="list-style: none; margin-bottom: 0">
        <li>
          <h3 style="font-weight: 500">{{ header }}</h3>
        </li>
        <li class="mt-2">
          <div class="rowflex">
            <div class="mr-2" style="width: 20%">
              <img style="width: 100%" src="@/assets/images/Stock/lo.png" />
            </div>
            <div class="wid36" style="width: 80%">
              <h5>{{ detail }}</h5>
            </div>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  props: ["header", "detail"],
};
</script>

<style scoped>
.rowflex {
  width: 100%;
  display: flex;
}
</style>